/**
 * HomeCompareRail — homepage section promoting 3 highest-traffic
 * anonymous comparison pages. Drives mid-funnel visitors to the
 * Phase J comparison surface without naming any competitor.
 */
import { Link } from "react-router-dom";
import { Scale, ArrowRight } from "lucide-react";

const FEATURED = [
    {
        slug: "delivery",
        label: "Delivery & coverage",
        teaser: "Same-day to 80+ ZIPs vs the typical NY retailer's tighter zone.",
    },
    {
        slug: "selection",
        label: "Strain & brand selection",
        teaser: "109+ cultivars, 80+ verified NY brands, full Dutchie integration.",
    },
    {
        slug: "reviews",
        label: "Customer reviews",
        teaser: "4.9★ from 4,300+ verified reviews — see how that stacks up.",
    },
];

export default function HomeCompareRail() {
    return (
        <section
            data-testid="home-compare-rail"
            className="bg-zen-bg border-y border-zen-line py-14 sm:py-16"
        >
            <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
                <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
                    <div>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-zen-olive mb-2 inline-flex items-center gap-2">
                            <Scale size={12} /> Honest comparisons
                        </p>
                        <h2 className="font-serif text-3xl sm:text-4xl text-zen-ink font-light leading-tight">
                            ZenZest vs other NY dispensaries
                        </h2>
                    </div>
                    <Link
                        to="/compare/zenzest-vs-other-dispensary"
                        data-testid="home-compare-see-all"
                        className="text-[11px] uppercase tracking-[0.25em] text-zen-olive hover:text-zen-olive-dark inline-flex items-center gap-1"
                    >
                        See all 8 comparisons <ArrowRight size={11} />
                    </Link>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {FEATURED.map((f) => (
                        <Link
                            key={f.slug}
                            to={`/compare/zenzest-vs-other-dispensary/${f.slug}`}
                            data-testid={`home-compare-${f.slug}`}
                            className="group block bg-white border border-zen-line p-5 hover:border-zen-olive transition"
                        >
                            <p className="text-[10px] uppercase tracking-[0.3em] text-zen-olive mb-2">
                                Compared
                            </p>
                            <h3 className="font-serif text-xl text-zen-ink leading-snug mb-2">
                                {f.label}
                            </h3>
                            <p className="text-[14px] text-zen-ink-soft leading-relaxed">
                                {f.teaser}
                            </p>
                            <p className="mt-3 text-[10px] uppercase tracking-[0.3em] text-zen-olive inline-flex items-center gap-1">
                                Read comparison <ArrowRight size={11} />
                            </p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
